
import { Component, Vue, Prop} from 'vue-property-decorator';
import LegalDutyDependentChildFsSurvey from "./LegalDutyDependentChildFSSurvey.vue";
import PageBase from "../../PageBase.vue";

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
import { stepInfoType, stepResultInfoType } from "@/types/Application";

@Component({
    components:{
        LegalDutyDependentChildFsSurvey,
        PageBase
    }
})
export default class LegalDutyDependentChildFS extends Vue {

    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[];    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    currentStep =0;
    currentPage =0;
    showTable = true;

    legalDutyDependentChildFsExists = null;  

    childExpenseData = [];
    anyRowToBeEdited = null;
    editId = null; 
    incompleteError =  false;
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
         Vue.nextTick(()=>{
            const el = document.getElementById('legal-duty-dependent-child-fs-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public childComponentData(value) {       
        this.showTable = value;
    }

    public populateSurveyData(childValue) {

        const currentIndexValue = this.childExpenseData?.length > 0 ? this.childExpenseData[this.childExpenseData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newChild = { ...childValue, id };
        this.childExpenseData = [...this.childExpenseData, newChild];

        this.showTable = true; 
    }

    public deleteRow(rowToBeDeleted) {
       
        this.childExpenseData = this.childExpenseData.filter(data => {
            return data.id !== rowToBeDeleted;
        });
        this.surveyHasError();
    }

    public editRow(editedRow) {
        this.childExpenseData = this.childExpenseData.map(data => {
            return data.id === this.editId ? editedRow : data;
        });
        this.showTable = true;
        this.surveyHasError();
    }

    public onPrev() {
       Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();
    }

    created() {

        if (this.step.result?.legalDutyDependentChildFsExists) {
            this.legalDutyDependentChildFsExists = this.step.result.legalDutyDependentChildFsExists;
        }

        if (this.step.result?.legalDutyDependentChildFSSurvey?.data) {
            this.childExpenseData = this.step.result.legalDutyDependentChildFSSurvey.data;
        }
             
    }

    mounted(){
        Vue.nextTick(()=>this.surveyHasError());
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
    }

    public surveyHasError(){
        let progress = this.childExpenseData.length==0? 50 : 100;
        
        if(this.legalDutyDependentChildFsExists == 'No') progress =100;

        this.incompleteError =  false;        
        for(const childExpense of this.childExpenseData){
            if ((this.legalDutyDependentChildFsExists=='Yes') && 
                (!childExpense.childFullName || !childExpense.monthlyPayment || !childExpense.yearlyPayment)){            
                this.incompleteError = true;  
                progress = 50;    
                break
            }
        }    

        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }

    public isDisableNext() {
        return (!this.legalDutyDependentChildFsExists || 
            (this.legalDutyDependentChildFsExists == 'Yes') 
            && this.childExpenseData?.length <= 0 );
    }

    beforeDestroy() {
        this.surveyHasError();  
        
        let childExpenseInfo = this.getChildExpenseResults()        
        
        if(this.legalDutyDependentChildFsExists == 'No')
            childExpenseInfo = null
        
        this.UpdateStepResultData(
            {
                step:this.step, 
                data: {
                    legalDutyDependentChildFsExists: this.legalDutyDependentChildFsExists,
                    legalDutyDependentChildFSSurvey: childExpenseInfo
                }
            }
        )       
    }

    public getChildExpenseResults(){
        const questionResults: {name:string; value: any; title:string; inputType:string}[] =[];
        for(const childExpense of this.childExpenseData)
        {
            questionResults.push({name:'legalDutyDependentChildFSSurvey', value: this.getChildExpenseInfo(childExpense), title:'Child Expense '+childExpense.id +' Information', inputType:''})
        }
        
        return {data: this.childExpenseData, questions:questionResults, pageName:'Child Expense Information', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getChildExpenseInfo(childExpense){
        const resultString = [];

        resultString.push(Vue.filter('styleTitle')("Name: ")+(childExpense.childFullName));
        resultString.push(Vue.filter('styleTitle')("Monthly Payment: ")+(childExpense.monthlyPayment));
        resultString.push(Vue.filter('styleTitle')("Yearly Payment: ")+(childExpense.yearlyPayment));

        return resultString
    } 
    
}
